// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3rMzS","validationTips":"StatementDescriptor_validationTips__IQGrb"};